<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 赋码管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>生码规则</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="90px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="规则名称" prop="productCode">
                <el-input type="text" v-model="searchform.productCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['coderule_select']"
              >搜索</el-button>
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button v-permission="['coderule_add']" type="primary" @click="addrule()">新增规则</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br id="A1" />
      <!-- 新增修改模块  -->
      <Order-Add :add="add" :search="search" />
      <Order-Update :update="update" :search="search" />
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <el-divider></el-divider>
          <el-table
            :stripe="true"
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
            @cell-click="danhang"
            height="450"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
          >
            <el-table-column prop="rule_name" label="规则名称" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="rule_link" label="链接" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="rule_max" label="单次最大生码量" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product_code" label="产品编码" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="创建时间" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="操作" min-width="160" fixed="right">
              <template slot-scope="props">
                <el-button-group>
                  <el-button
                    v-permission="['coderule_update']"
                    type="primary"
                    icon="el-icon-edit"
                    @click="getoutbilldata(props.row.rule_id,props.row),update.show =true , add.addshow=false"
                  ></el-button>
                  <el-button
                    type="danger"
                    v-permission="['coderule_delete']"
                    icon="el-icon-delete"
                    @click="deletedate(props.row.rule_id)"
                  ></el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[20,30,40,100]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { findmaster, finddetail, codedelete, geturl } from "@/api/tagging";
import OrderAdd from "./components/OrderAdd";
import OrderUpdate from "./components/OrderUpdate";
export default {
  name: "orderlist",
  components: { OrderAdd, OrderUpdate },
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata();
  },
  data() {
    return {
      workorder_status: [
        {
          value: 0,
          label: "新数据"
        },
        {
          value: 1,
          label: "历史数据"
        }
      ],
      //基础数据
      add: {
        rule_link: null,
        addshow: false
      },
      update: {
        form: {
          rule_id: null,
          rule_name: null,
          rule_link: null,
          rule_max: null,
          product_code:null,
          qrcodeRule: []
        },
        show: false
      },
      orderNo: "",
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      codearr: [],
      searchform: {
        productCode: null,
        pageIndex: 1,
        pageSize: 20
      }
    };
  },
  methods: {
    Tabledata(obj) {
      // 列表获取
      this.listLoading = true;
      findmaster(obj).then(response => {
        this.tableData = response.data.data;
        this.packdate(this.tableData);
        this.currentPage = response.data.page_index;
        this.total_count = response.data.total_count;
        this.listLoading = false;
        console.log(response.data);
      });
    },
    packdate(obj) {
      // 拼表格数据
      for (let i = 0; i < obj.length; i++) {
       obj[i].create_time = obj[i].create_time.replace(
          /T/,
          " "
        );
      }
    },
    //搜索事件
    search() {
      typeof this.searchform.workshopCode;
      this.Tabledata({
        productCode: this.searchform.productCode,
        pageSize: this.searchform.pageSize
      });
    },
    // 新增按钮 下载链接geturl
    addrule() {
        // this.add.rule_link = response.data;
        this.add.addshow = !this.add.addshow;
        this.update.show = false;
    },
    // 修改按钮 下载出库单
    getoutbilldata(id, row) {
      document.getElementById("A1").scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth"
      });
      finddetail({
        id: id
      }).then(response => {
        this.update.form = row;
        for (let i = 0; i < response.data.length; i++) {
          switch (response.data[i].rule_type) {
            case 1:
              response.data[i].rule_typename = "年月日";
              break;
            case 2:
              response.data[i].rule_typename = "输入固定字符";
              break;
            case 3:
              response.data[i].rule_typename = "自增长数字";
              break;
            case 4:
              response.data[i].rule_typename = "不重复随机数";
              break;
            case 5:
              response.data[i].rule_typename = "不重复随机数+字母";
              break;

            default:
              break;
          }
          switch (response.data[i].rule_name) {
            case 1:
              response.data[i].rule_namemean = "生码日期";
              break;
            case 2:
              response.data[i].rule_namemean = "包装级别";
              break;
            case 3:
              response.data[i].rule_namemean = "产品简码";
              break;
            case 4:
              response.data[i].rule_namemean = "自增长";
              break;
            case 5:
              response.data[i].rule_namemean = "自定义";
              break;
            case 6:
              response.data[i].rule_namemean = "企业编码";
              break;
            case 7:
              response.data[i].rule_namemean = "版本号";
              break;

            default:
              break;
          }
          
        }
        this.update.form.qrcodeRule = response.data;
        console.log(this.update.form.qrcodeRule);
      });
    },
    //删除按钮事件
    deletedate(id) {
      this.$confirm("此操作将永久删除该规则信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          codedelete({
            id: id
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //重置按钮
    resetForm(formName) {
      this.codearr = [];
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(page_index) {
      this.searchform.pageIndex = page_index;
      this.Tabledata({
        productCode: this.searchform.productCode,
        pageIndex: this.searchform.pageIndex,
        pageSize: this.searchform.pageSize
      });
    },
    //分页每页显示条数事件
    pagesize(page_size) {
      this.searchform.pageSize = page_size;
      this.search();
    },
    //单行点击
    danhang(row) {
      this.orderNo = row.orderno;
      console.log(row);
    }
  }
};
</script>
<style scoped>
</style>
